
import axios from "axios";
import { AppMessage } from "components";
import { store } from "store";
import { configUpdate } from "store/config";
import { OutputBaseProps } from "utils/types/API";
import { ConfigItemProps } from ".";

type ApiConfigOutputProps = OutputBaseProps<{ item: ConfigItemProps }, ConfigItemProps>

export const apiUpdateConfig = async (data: ConfigItemProps) => {
    const res = (await axios.put<ApiConfigOutputProps>("/api/config", data))
        .data;
    if (res.code === 0 && res.data) {
        store.dispatch(configUpdate(res.data.item));
    }
    if (res.code === 0) {
        AppMessage.success({
            title: "Thông báo",
            message: res.message
        })
    }
    return res;
};
